import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const boxStyles = {
  minHeight: "200px",
  color: "#fff",
};

const titleStyles = {
  fontSize: "1em",
  textDecoration: "none",
  textTransform: "uppercase",
};

export default function LandingBox(props) {
  const { title, navigatePath, image } = props;
  return (
    <Col lg={6}>
      <Link to={navigatePath} style={titleStyles}>
        <Col
          className="position-relative rounded"
          id="landingBox"
          style={boxStyles}>
          <div
            className="position-absolute"
            style={{ bottom: "10px", right: "20px" }}>
            <h3 style={{ fontWeight: "600" }}>{title}</h3>
          </div>
        </Col>
      </Link>
    </Col>
  );
}
